import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiHelper } from '../../../core/services/apiHelper';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit, OnDestroy {
  envName: string;

  clientCommit: string;
  clientBuild: string;
  clientRelease: string;

  mainCommit: string;
  mainBuild: string;
  mainRelease: string;

  dataCommit: string;
  dataBuild: string;
  dataRelease: string;

  detCommit: string;
  detBuild: string;
  detRelease: string;

  private subs: Array<Subscription> = [];

  constructor(private apiHelper: ApiHelper) {}

  ngOnInit(): void {
    this.envName = environment.envName;
    this.clientCommit = environment.gitCommit;
    this.clientBuild = environment.buildNumber;
    this.clientRelease = environment.release;

    let mainSub = this.apiHelper
      .apiCall(this.apiHelper.getServiceName(), 'GET', null, null, this.apiHelper.getDefaultHeader())
      .subscribe(
        (res: any) => {
          if (res) {
            this.mainBuild = res.build;
            this.mainCommit = res.commit;
            this.mainRelease = res.release;
          }
        },
        err => console.error(err)
      );
    this.subs.push(mainSub);

    let dataSub = this.apiHelper
      .apiCall(this.apiHelper.getServiceName('data'), 'GET', null, null, this.apiHelper.getDefaultHeader())
      .subscribe(
        (res: any) => {
          if (res) {
            this.dataBuild = res.build;
            this.dataCommit = res.commit;
            this.dataRelease = res.release;
          }
        },
        err => console.error(err)
      );
    this.subs.push(dataSub);

    let detSub = this.apiHelper
      .apiCall(this.apiHelper.getServiceName('det'), 'GET', null, null, this.apiHelper.getDefaultHeader())
      .subscribe(
        (res: any) => {
          if (res) {
            this.detBuild = res.build;
            this.detCommit = res.commit;
            this.detRelease = res.release;
          }
        },
        err => console.error(err)
      );
    this.subs.push(detSub);
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
